import { HeaderContainer } from "./stylesHeader";
import logo from '../../assets/logo1.jpg';
import { Link, useNavigate } from "react-router-dom";
import { getAuth, signOut } from 'firebase/auth';
import { loggedUser } from "../../state/atom";
import { useRecoilValue } from "recoil";
import { auth } from "../../service";
import { useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { tertiaryColor } from "../../styles/variables";

export default function Header() {
    const navigate = useNavigate();

    let userImage: string = "";
    if (auth.currentUser !== null && auth.currentUser.photoURL !== null) userImage = auth.currentUser.photoURL;


    return (
        <>
            <HeaderContainer>
                <Link to="/">
                    <img src={logo} alt="Logo do app" />
                </Link>

                <Navbar bg={tertiaryColor} expand="lg" variant="dark">
                    <Container >
                        <Navbar.Brand as="h1" className="text-white" onClick={() => navigate('/')}>CompraMinhApp</Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse  id="basic-navbar-nav">
                            <Nav className="me-auto">
                                <NavDropdown className="text-white" title={<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" className="bi bi-list" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
</svg>
} id="basic-nav-dropdown">
                                    <NavDropdown.Item onClick={() => navigate('/')}> Home</NavDropdown.Item>
                                    <NavDropdown.Item onClick={() => navigate('/minhas-listas')}>Suas Listas</NavDropdown.Item>
                                    <NavDropdown.Item onClick={() => navigate('/')}>Editar o perfil</NavDropdown.Item>
                                    <NavDropdown.Item onClick={() => navigate('/')}>
                                        Sobre Nós
                                    </NavDropdown.Item>
                                    <NavDropdown.Divider />
                                    <NavDropdown.Item onClick={() => {
                                    auth.signOut().then(res => {
                                        alert("Usuário saiu do perfil");
                                        navigate('/');
                                    });
                                }}>
                                        Sair do perfil
                                    </NavDropdown.Item>
                                </NavDropdown>
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
                {auth.currentUser !== null ?
                            (<div className="profile-header">
                                {<img src={userImage} alt="imagem do perfil" />}
                                <p>Olá, {auth.currentUser?.displayName}</p><br />

                                <button onClick={() => {
                                    auth.signOut().then(res => {
                                        alert("Usuário saiu do perfil");
                                        navigate('/');
                                    });
                                }}>Sair</button>
                            </div>)
                            :
                            <aside><Link to="/login">Login/Cadastro</Link></aside>}

               
            </HeaderContainer>
        </>
    );
}